import React, { useEffect, useState } from 'react';
import { getTestimonials } from "../api/testimonialService";
import { sleep } from "../utils/sleep";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';



const Testimonials = () => {
  const [slidesPerView, setSlidesPerView] = useState(window.innerWidth <= 768 ? 1 : 2);
const [testimonials, setTestimonials] = useState([]);
            const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const handleResize = () => {
      setSlidesPerView(window.innerWidth <= 768 ? 1 : 2);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [testimonials]);


  
          
              useEffect(() => {
              const fetchTestimonials = async () => {
                try {
                  // simulate network delay (3 sec)
                  //await sleep(3000);
          
                  const data = await getTestimonials(); // asynchronous call
                  setTestimonials(data);
                } catch (err) {
                  setError("Failed to load testimonials.");
                } finally {
                  setLoading(false);
                }
              };
          
              fetchTestimonials();
              }, []);
            
            // Loading Overlay
            if (loading) {
              return (
                <div className="loading-overlay d-flex align-items-center justify-content-center py-5">
                  <div className="spinner-border text-primary" role="status"></div>
                  <span className="ms-3 fw-semibold">Loading testimonials...</span>
                </div>
              );
            }
            
             // Error Message
            if (error) {
              return (
                <div className="error-container d-flex flex-column align-items-center justify-content-center py-5">
                  <p className="text-danger fs-7">{error}</p>
                  <button
                    className="btn btn-outline-primary mt-3"
                    onClick={() => window.location.reload()}
                  >
                    Retry
                  </button>
                </div>
              );
      }

  return (
    <section className="py-5">
      <div className="container text-center">
        <h2 className="fw-bold mb-4">What Our Clients <span className="text-primary-color">Say</span></h2>
<p className="text-muted mb-5">
  Hear from our satisfied clients who have experienced transformative results through our work.
</p>
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerGroup={slidesPerView}
          slidesPerView={slidesPerView}
          autoHeight={true}
          pagination={{
            el: '.custom-pagination',
            clickable: true,
          }}
          autoplay={{ delay: 4000 }}
          loop={true}
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-card">
                <p className="fst-italic">“{testimonial.message}”</p>
                <h6 className="fw-bold mb-0 mt-3">{testimonial.name}</h6>
                <small className="text-muted">{testimonial.designation}</small>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="custom-pagination mt-4"></div>
      </div>
    </section>
  );
};

export default Testimonials;
